import { render } from "./FormCheckList.vue?vue&type=template&id=00f2b0bb&scoped=true"
import script from "./FormCheckList.vue?vue&type=script&lang=js"
export * from "./FormCheckList.vue?vue&type=script&lang=js"

import "./FormCheckList.vue?vue&type=style&index=0&id=00f2b0bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f2b0bb"]])

export default __exports__